export default {
  files(state) {
    return state.files
  },
}
